"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getTabActiveColor = exports.getActiveBorderRange = void 0;
var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));
require("core-js/modules/es6.array.find-index.js");
require("core-js/modules/es6.array.map.js");
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));
var _lodash = require("lodash");
var _constants = require("./constants");
var _excluded = ["currentTheme"];
/* eslint-disable import/prefer-default-export */
function cov_f7i9129kw() {
  var path = "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/helper.js";
  var hash = "29154ca7a9a6d91b070a25c185d9ed34ed339f2a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3154135081/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Tabs/lib/helper.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 10
        },
        end: {
          line: 5,
          column: 44
        }
      },
      "1": {
        start: {
          line: 7,
          column: 33
        },
        end: {
          line: 8,
          column: 98
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 8,
          column: 98
        }
      },
      "3": {
        start: {
          line: 23,
          column: 36
        },
        end: {
          line: 34,
          column: 1
        }
      },
      "4": {
        start: {
          line: 24,
          column: 22
        },
        end: {
          line: 24,
          column: 49
        }
      },
      "5": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 27,
          column: 3
        }
      },
      "6": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 18
        }
      },
      "7": {
        start: {
          line: 29,
          column: 19
        },
        end: {
          line: 29,
          column: 59
        }
      },
      "8": {
        start: {
          line: 30,
          column: 16
        },
        end: {
          line: 30,
          column: 74
        }
      },
      "9": {
        start: {
          line: 31,
          column: 15
        },
        end: {
          line: 31,
          column: 67
        }
      },
      "10": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 33
          },
          end: {
            line: 7,
            column: 34
          }
        },
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 98
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 36
          },
          end: {
            line: 23,
            column: 37
          }
        },
        loc: {
          start: {
            line: 23,
            column: 67
          },
          end: {
            line: 34,
            column: 1
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 6
          },
          end: {
            line: 25,
            column: 26
          }
        }, {
          start: {
            line: 25,
            column: 30
          },
          end: {
            line: 25,
            column: 45
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "29154ca7a9a6d91b070a25c185d9ed34ed339f2a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_f7i9129kw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_f7i9129kw();
var _ = (cov_f7i9129kw().s[0]++, {
  findIndex: _lodash.findIndex,
  get: _lodash.get,
  map: _lodash.map,
  sum: _lodash.sum,
  take: _lodash.take
});
cov_f7i9129kw().s[1]++;
var getTabActiveColor = exports.getTabActiveColor = function getTabActiveColor(_ref) {
  var currentTheme = _ref.currentTheme,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  cov_f7i9129kw().f[0]++;
  cov_f7i9129kw().s[2]++;
  return _.get(props, _constants.THEME_PROPS_PATH.tabActiveColor, _constants.THEMED_DEFAULT_VALUE[currentTheme].tabActiveColor);
};

/**
 * Gets the start and size offset positions of the active tab's border.
 *
 * This function calculates the range of the active tab's border by
 * determining its start and end positions within its parent container.
 * It assumes that `tabsListHtmlElement` is a reference to the parent container
 * of the tabs and that `tabs` is an array where one of the tabs has an
 * `active` property set to `true`.
 *
 * @param {Array<{ active: true }>} tabs - An array of tab objects.
 * @param {HTMLElement} [tabsListHtmlElement] - The HTML element that contains the tabs.
 * @returns {[number, number]} An array [start, size] containing the start and size offset positions of the active tab's border.
 */
cov_f7i9129kw().s[3]++;
var getActiveBorderRange = exports.getActiveBorderRange = function getActiveBorderRange(tabs, tabsListHtmlElement) {
  cov_f7i9129kw().f[1]++;
  var activeIndex = (cov_f7i9129kw().s[4]++, _.findIndex(tabs, 'active'));
  cov_f7i9129kw().s[5]++;
  if ((cov_f7i9129kw().b[1][0]++, !tabsListHtmlElement) || (cov_f7i9129kw().b[1][1]++, activeIndex < 0)) {
    cov_f7i9129kw().b[0][0]++;
    cov_f7i9129kw().s[6]++;
    return [0, 0];
  } else {
    cov_f7i9129kw().b[0][1]++;
  }
  var children = (cov_f7i9129kw().s[7]++, (0, _from.default)(tabsListHtmlElement.children));
  var start = (cov_f7i9129kw().s[8]++, _.sum(_.take(_.map(children, 'offsetWidth'), activeIndex)));
  var size = (cov_f7i9129kw().s[9]++, _.get(children, [activeIndex, 'offsetWidth'], 0) - 1);
  cov_f7i9129kw().s[10]++;
  return [start, size];
};